import React, { useState, useEffect, useCallback } from 'react';
import { InputText, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { Alert } from 'react-bootstrap';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';
import { typeDetail } from 'core/constant/SELECT_OPTIONS';

const EditProjectFloorPlanModal = ({ show, floorPlan, handleClose, handleSave, updating, errors, requestError, projectsOptions, features, deleteFeature }) => {
  const [formValues, setFormValues] = useState(floorPlan);
  const [internalFeatures, setInternalFeatures] = useState(features);
  const [featuresToDelete, setFeaturesToDelete] = useState([]);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(floorPlan);
    setInternalFeatures(features);
  }, [floorPlan, features]);

  const handleFeatureChange = (index, key, value) => {
    const newFeatures = [...internalFeatures];
    newFeatures[index] = { ...newFeatures[index], [key]: value };
    setInternalFeatures(newFeatures);
  };

  const addFeature = () => {
    setInternalFeatures([...internalFeatures, { label: "", value: "" }]);
  };

  const removeFeature = (index) => {
    const feature = internalFeatures[index];
    if (feature.id) {
      setFeaturesToDelete([...featuresToDelete, feature.id]);
    }
    setInternalFeatures(internalFeatures.filter((_, i) => i !== index));
  };

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: floorPlan?.id }, internalFeatures, featuresToDelete);
  }, [formValues, floorPlan?.id, handleSave, internalFeatures, featuresToDelete]);

  const handleDropdownChange = (e) => {
    handleChange('name', e.target.value);
    if (internalFeatures.length === 0) {
      addFeature();
    }
  };

  return (
    <BaseModalForm show={show} title={floorPlan?.id ? "Editar Detalle de Proyecto" : "Crear Detalle de Proyecto"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-12 form-group">
          <DropdownField
            label="Proyecto"
            value={formValues?.project_id}
            options={projectsOptions}
            onChange={(e) => handleChange('project_id', e.target.value)}
            placeholder="Seleccione un proyecto"
            error={errors?.project_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <DropdownField
              label="Tipo de Detalle"
              name="name"
              value={formValues?.name}
              options={typeDetail}
              onChange={handleDropdownChange}
              placeholder="Seleccione un tipo de detalle"
              error={errors?.name}
            />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            name="description"
            label="Descripción"
            value={formValues?.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Ingrese la descripción"
            error={errors?.description}
          />
        </div>
        <section className="m-0 p-0">
          <div className="row">
            {internalFeatures?.map((feature, index) => (
              <React.Fragment key={index}>
                <div className="col-md-5">
                  <InputText
                    name="label"
                    label="Nombre del Valor"
                    value={feature.label}
                    onChange={(e) => handleFeatureChange(index, 'label', e.target.value)}
                    error={errors[index]?.label}
                  />
                </div>
                <div className="col-md-6">
                  <InputText
                    name="value"
                    label="Valor"
                    value={feature.value}
                    onChange={(e) => handleFeatureChange(index, 'value', e.target.value)}
                    error={errors[index]?.value}
                  />
                </div>
                <div className="col-md-1">
                  <div className="d-flex justify-content-end align-items-center h-100">
                    <i className={feature.icon} style={{ fontSize: '24px', marginRight: '10px' }} />
                    <button
                      type="button"
                      onClick={() => removeFeature(index)}
                      className="delete-table delete-button me-2"
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
          <button className="btn btn-primary-400 ms-3 mb-3" type="button" onClick={addFeature}>
            <i className="fa fa-plus-circle me-2" aria-hidden="true" />
            Añadir Valor
          </button>
        </section>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.FLOOR_PLANS}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditProjectFloorPlanModal);
